import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";

const AddBookModal = ({
  show,
  onHide,
  bookData,
  setBookData,
  handleFileChange,
  handleSubmit,
  loading,
}) => {
  const { t } = useTranslation();
  const fileInputRef = useRef();

  const onFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(e);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("add_new")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="addBookForm" onSubmit={onFormSubmit}>
          <div className="row">
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label">{t("cover_image")}</label>
                <div
                  className="drop-zone"
                  onClick={() => fileInputRef.current.click()}
                  style={{ cursor: "pointer" }}
                >
                  {bookData.coverImage && (
                    <img
                      src={URL.createObjectURL(bookData.coverImage)}
                      alt="preview"
                      style={{ width: "100px", marginTop: "10px" }}
                    />
                  )}

                  <span className="drop-zone__prompt">
                    <i className="fas fa-upload"></i>
                    <br />
                    <span>{t("upload_image")}</span>
                  </span>

                  <input
                    type="file"
                    name="bookCoverImage"
                    className="drop-zone__input"
                    accept="image/*"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                    style={{ display: "none" }}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-8">
              <div className="mb-3">
                <label htmlFor="bookTitleAr" className="form-label">
                  {t("book_title_ar")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="bookTitleAr"
                  name="bookTitleAr"
                  value={bookData.arabicTitle}
                  onChange={(e) =>
                    setBookData({ ...bookData, arabicTitle: e.target.value })
                  }
                />
              </div>

              <div className="mb-3">
                <label htmlFor="bookTitleEn" className="form-label">
                  {t("book_title_en")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="bookTitleEn"
                  name="bookTitleEn"
                  value={bookData.englishTitle}
                  onChange={(e) =>
                    setBookData({ ...bookData, englishTitle: e.target.value })
                  }
                />
              </div>

              <div className="mb-3">
                <label htmlFor="bookUrl" className="form-label">
                  {t("url")}
                </label>
                <input
                  type="url"
                  className="form-control"
                  id="bookUrl"
                  name="bookUrl"
                  placeholder="https://example.com"
                  value={bookData.link}
                  onChange={(e) =>
                    setBookData({ ...bookData, link: e.target.value })
                  }
                />
              </div>
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="bookAboutAr" className="form-label">
              {t("book_about_ar")}
            </label>
            <textarea
              className="form-control"
              id="bookAboutAr"
              name="bookAboutAr"
              rows="3"
              value={bookData.arabicDescription}
              onChange={(e) =>
                setBookData({
                  ...bookData,
                  arabicDescription: e.target.value,
                })
              }
            ></textarea>
          </div>

          <div className="mb-3">
            <label htmlFor="bookAboutEn" className="form-label">
              {t("book_about_en")}
            </label>
            <textarea
              className="form-control"
              id="bookAboutEn"
              name="bookAboutEn"
              rows="3"
              value={bookData.englishDescription}
              onChange={(e) =>
                setBookData({
                  ...bookData,
                  englishDescription: e.target.value,
                })
              }
            ></textarea>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          {t("cancel")}
        </Button>
        <Button
          variant="primary"
          type="submit"
          form="addBookForm"
          disabled={loading}
        >
          {loading ? t("loading") : t("save_changes")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddBookModal;
